import { IUpsell, IRefusalUpsell } from '@/interfaces/Upsell';

import RefusalUpsell from './RefusalUpsell';

export class Upsell implements IUpsell {
  id: number;
  name: string;
  description: string;
  html_description: string;
  offer_id: number;
  offer_slug: string;
  price: number;
  is_bankslip_available: boolean;
  countdown: number;
  url_for_refusal_action: string;
  params: any[];
  is_active: true;
  error_code: null;
  custom_template: string;
  target_content_url: string;
  refusal_upsell?: IRefusalUpsell;
  model?: string | null;
  button_text?: string | null;
  button_url?: string | null;
  sales_channel?: string | null;

  constructor(upsell: any) {
    this.id = upsell.id;
    this.name = upsell.name;
    this.description = upsell.description;
    this.html_description = upsell.html_description;
    this.offer_id = upsell.offer_id;
    this.offer_slug = upsell.offer_slug;
    this.price = upsell.price;
    this.is_bankslip_available = upsell.is_bankslip_available;
    this.countdown = upsell.countdown;
    this.url_for_refusal_action = upsell.url_for_refusal_action;
    this.params = upsell.params;
    this.is_active = upsell.is_active;
    this.error_code = upsell.error_code;
    this.custom_template = upsell.custom_template;
    this.target_content_url = upsell.target_content_url;
    this.model = upsell.model;
    this.button_text = upsell.button_text;
    this.button_url = upsell.button_url;
    this.sales_channel = upsell.sales_channel;

    if (upsell.refusal_upsell) {
      this.refusal_upsell = new RefusalUpsell(upsell.refusal_upsell);
    }
  }
}
